import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { adminApi } from "@/lib/adminAuth";
import { Users, Crown, Sparkles, DollarSign, Star } from "lucide-react";

export default function AdminDashboard() {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/admin/metrics", adminApi()).then(({ data }) => setM(data)); }, []);
  if (!m) return <div className="text-white/60 font-admin-body">Yükleniyor...</div>;

  const stats = [
    { label: "Toplam Kullanıcı", value: m.total_users, icon: Users },
    { label: "Premium Üye", value: m.premium_users, icon: Crown },
    { label: "Toplam Fal", value: m.total_fortunes, icon: Sparkles },
    { label: "Ödemeler", value: m.paid_transactions, icon: Star },
    { label: "Gelir (USD)", value: `$${m.revenue_usd}`, icon: DollarSign },
  ];

  return (
    <div className="font-admin-body">
      <h1 className="font-admin-head text-3xl mb-6">Genel Bakış</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-8">
        {stats.map((s) => {
          const Icon = s.icon;
          return (
            <div key={s.label} className="admin-card p-4" data-testid={`stat-${s.label}`}>
              <Icon className="w-5 h-5 text-[#F59E0B] mb-2" />
              <div className="text-xs text-white/50 uppercase tracking-wider">{s.label}</div>
              <div className="font-admin-head text-3xl mt-1">{s.value}</div>
            </div>
          );
        })}
      </div>

      <div className="admin-card p-5">
        <h2 className="font-admin-head text-xl mb-4">Fal Türlerine Göre</h2>
        <div className="space-y-2">
          {m.fortunes_by_type.length === 0 && <div className="text-sm text-white/50">Henüz fal yok</div>}
          {m.fortunes_by_type.map((f) => {
            const max = Math.max(...m.fortunes_by_type.map((x) => x.count));
            const w = (f.count / max) * 100;
            return (
              <div key={f._id} className="flex items-center gap-3 text-sm">
                <div className="w-24 text-white/70 capitalize">{f._id}</div>
                <div className="flex-1 bg-white/5 rounded h-6 relative overflow-hidden">
                  <div className="h-full bg-[#F59E0B]/40" style={{ width: `${w}%` }} />
                  <div className="absolute inset-0 flex items-center px-2 text-xs font-semibold">{f.count}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
